import { useQuery, UseQueryOptions } from 'react-query';
import { useService } from '@core/inversify-react';

import { GetBranchByIdRepoType, IGetBranchByIdRepo } from '../repos';
import { IBranchById } from '../interfaces';

export const useBranchById = (id?: string, options?: UseQueryOptions<IBranchById, Error, IBranchById, string[]>) => {
  const getCourierByIdRepo = useService<IGetBranchByIdRepo>(GetBranchByIdRepoType);

  return useQuery<IBranchById, Error, IBranchById, string[]>(
    ['orders', id || ''],
    async ({ queryKey }) => {
      const [, id] = queryKey;
      const result = await getCourierByIdRepo.execute(id);

      if (result.status === 200) {
        return result.response;
      } else {
        throw new Error(result.response);
      }
    },
    options,
  );
};
